import React, { useState } from 'react';

// 0=金额 1=数量 2=百分比
export type CalcType = 0 | 1 | 2;

interface CalcRadioGroupProps {
    value: CalcType;
    onChange: (value: CalcType) => void;
    options: { id: CalcType; label: string }[];
}

const PRIMARY = '#1fc7d4';


export const ONLY_AMOUNT: { id: CalcType; label: string }[] = [
    { id: 0, label: '金额' },
];
// 买入：只有金额 / 数量
export const BUY_OPTIONS: { id: CalcType; label: string }[] = [
    { id: 0, label: '金额' },
    { id: 1, label: '数量' },
];

// 卖出：百分比 / 金额 / 数量
export const SELL_OPTIONS: { id: CalcType; label: string }[] = [
    { id: 2, label: '百分比' },
    { id: 0, label: '金额' },
    { id: 1, label: '数量' },
];
export const SELL_OPTIONS1: { id: CalcType; label: string }[] = [
    { id: 2, label: '百分比' },
    { id: 1, label: '数量' },
];
export const walletUse: { id: CalcType; label: string }[] = [
    { id: 0, label: '顺序' },
    { id: 1, label: '随机' },
];

const CalcRadioGroup: React.FC<CalcRadioGroupProps> = ({
    value,
    onChange,
    options,
}) => {
    const [hovered, setHovered] = useState<CalcType | null>(null);

    const containerStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        gap: '18px',
        flexWrap: 'wrap',
    };

    const getItemStyle = (id: CalcType): React.CSSProperties => {
        const isActive = value === id;
        const isHovered = hovered === id && !isActive;
        return {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            userSelect: 'none',
            transition: 'all 0.15s ease',
            transform: isHovered ? 'scale(1.04)' : 'scale(1)',
        };
    };

    const getRingStyle = (id: CalcType): React.CSSProperties => {
        const isActive = value === id;
        return {
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#ffffff',
            border: isActive ? `2px solid ${PRIMARY}` : '2px solid #cdd3d8',
            boxSizing: 'border-box',
            transition: 'all 0.15s ease',
        };
    };

    const getDotStyle = (id: CalcType): React.CSSProperties => {
        const isActive = value === id;
        return {
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: isActive ? PRIMARY : 'transparent',
            transition: 'all 0.15s ease',
        };
    };

    const getLabelStyle = (id: CalcType): React.CSSProperties => {
        const isActive = value === id;
        return {
            marginLeft: '6px',
            fontSize: '14px',
            color:  '#6b7580',
            fontWeight: isActive ? 500 : 400,
            transition: 'all 0.15s ease',
        };
    };

    return (
        <div style={containerStyle}>
            {options.map((opt) => {
                const isActive = value === opt.id;
                return (
                    <div
                        key={opt.id}
                        style={getItemStyle(opt.id)}
                        onClick={() => onChange(opt.id)}
                        onMouseEnter={() => setHovered(opt.id)}
                        onMouseLeave={() => setHovered(null)}
                        role="radio"
                        aria-checked={isActive}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onChange(opt.id);
                            }
                        }}
                    >
                        <div style={getRingStyle(opt.id)}>
                            <div style={getDotStyle(opt.id)} />
                        </div>
                        <span style={getLabelStyle(opt.id)}>{opt.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default CalcRadioGroup;